import { Card, CardContent } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Project, SupportComment, TwitterHashTags } from "interfaces/front/business";
import { goErrorPage } from "lib/frontRouting";
import { useActivation } from "lib/hooks/useActivation";
import { FrontOrderService } from "lib/service/client/FrontOrderService";
import { infoToast } from "lib/toast";
import { useRouter } from "next/router";
import React, { FC, useEffect, useState } from "react";
import { MessageText } from "../../../admin/message/MessageText";
import { SsDialogOpenButton } from "../../layout/SsDialogOpenButton";
import { TwitterShareButton } from "../../layout/TwitterShareButton";
import { CommentInput, SupportCommentEditModal } from "./SupportCommentEditModal";

type SupportCommentAreaProps = {
  project: Pick<Project, "code"> & {
    content: TwitterHashTags;
  };
  orderCode: string;
  supportComment?: SupportComment;
};
export const SupportCommentArea: FC<SupportCommentAreaProps> = ({ project, orderCode, supportComment }) => {
  const [isOpenModal, openModal, closeModal] = useActivation(false);
  const [comment, setComment] = useState<string>(supportComment?.comment || "");
  const router = useRouter();
  const service = new FrontOrderService(router);
  const onChangeSupportComment = async (commentInput: CommentInput | undefined) => {
    if (!commentInput?.comment) return;
    const onSuccess = async () => {
      await setComment(commentInput.comment);
      await infoToast("応援コメントを変更しました。");
    };
    const onFailure = async () => {
      await goErrorPage(router);
    };
    await service.updateComment(orderCode, { comment: commentInput.comment }, onSuccess, onFailure);
  };
  useEffect(() => {
    if (supportComment?.comment) {
      setComment(supportComment?.comment);
    }
  }, [supportComment?.comment]);
  const classes = useStyles();
  return (
    <>
      <Card variant={"outlined"} style={{ margin: "10px 0" }}>
        <CardContent>
          <div className={classes.cardText}>
            <MessageText message={comment} />
          </div>
        </CardContent>
      </Card>
      <SsDialogOpenButton label="応援コメントを変更する" onClick={openModal} margin="20px auto" />
      <TwitterShareButton
        projectCode={project.code}
        twitterHashTags={project.content}
        tweetText={comment}
        style={{ textAlign: "center" }}
      />
      <SupportCommentEditModal
        isOpen={isOpenModal}
        initialValue={{ comment: comment }}
        closeHandle={async (commentInput): Promise<void> => {
          await closeModal();
          await onChangeSupportComment(commentInput);
        }}
      />
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  cardText: {
    marginBottom: "10px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "17px",
    },
  },
}));
